import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './search-results-main-display.component.scss';
var SearchResultsMainDisplay = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsMainDisplay, _super);
    function SearchResultsMainDisplay(element) {
        return _super.call(this, element) || this;
    }
    SearchResultsMainDisplay.prototype.init = function () {
        this.containerFilterBuilder = this.element.querySelector('.filter-builder__form-field--container');
        if (this.element.getAttribute('data-jsonfile')) {
            this.dataJsonFile = this.element.getAttribute('data-jsonfile');
            this.createSearchContainer();
        }
    };
    SearchResultsMainDisplay.prototype.bindEvents = function () {
    };
    SearchResultsMainDisplay.prototype.createSearchContainer = function () {
        var _this = this;
        // create container
        var output = "<div class=\"search-results-main-display__autocomplete d-none\"></div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        this.containerFilterBuilder.appendChild(docfragment);
        // bind vars
        this.containerSearchResults = this.element.querySelector('.search-results-main-display__autocomplete');
        this.inputSearch = this.element.querySelector('.js-search-bar');
        this.inputButtonClear = this.element.querySelector('.filter-builder__form-field--searchbuttonclear');
        // on searchbar keydown
        this.inputSearch.addEventListener('keydown', this.debounce(function (event) {
            _this.containerSearchResults.classList.add('d-none');
            _this.containerSearchResults.innerHTML = '';
            var lastSearch = _this.inputSearch.value.toLowerCase();
            if (lastSearch.length >= 4) {
                _this.containerSearchResults.innerHTML = '<img class="search__results-busy" src="/file_source/assets/img/spinner.gif" />';
                _this.containerFilterBuilder.classList.add('searching');
                _this.containerSearchResults.classList.remove('d-none');
                _this.http.get(_this.dataJsonFile).then(function (response) {
                    var docfragment = document.createDocumentFragment();
                    var filter = response.data.filter(function (item) {
                        return item.searchCriteria.toLowerCase().indexOf(lastSearch) > -1;
                    }).sort(function (a, b) {
                        return a.weight - b.weight;
                    });
                    if (filter.length === 0) {
                    }
                    else {
                        _this.containerSearchResults.innerHTML = '';
                        filter.forEach(function (element, index) {
                            if (index >= 5) {
                                return;
                            }
                            var target = '';
                            docfragment.appendChild(document.createRange().createContextualFragment("\n\t\t\t\t\t\t\t\t<a href=\"" + element.relatedPage + "\" " + target + ">\n\t\t\t\t\t\t\t\t\t" + element.searchCriteria + "\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t"));
                        });
                        _this.containerSearchResults.appendChild(docfragment);
                    }
                });
            }
            else {
                _this.containerFilterBuilder.classList.remove('searching');
            }
        }, 200, false));
        // buttons
        this.inputButtonClear.addEventListener('click', function (event) {
            _this.containerSearchResults.classList.add('d-none');
            _this.containerSearchResults.innerHTML = '';
        });
    };
    SearchResultsMainDisplay.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    return SearchResultsMainDisplay;
}(Base));
export { SearchResultsMainDisplay };



//////////////////
// WEBPACK FOOTER
// ./components/search-results-main-display/search-results-main-display.component.ts
// module id = 677
// module chunks = 0